"use strict";
exports.__esModule = true;
exports.Stepper = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var button_1 = tslib_1.__importDefault(require("../button"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var stepper_style_1 = require("./stepper.style");
var Stepper = function (_a) {
    var _b = _a.method, method = _b === void 0 ? 'increment' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, color = _a.color, className = _a.className, rest = tslib_1.__rest(_a, ["method", "size", "color", "className"]);
    return (react_1["default"].createElement(button_1["default"], tslib_1.__assign({ size: size, shape: 'square', rounded: 'full', color: color, className: (0, class_names_1["default"])(className, stepper_style_1.SIZES[size]) }, rest),
        react_1["default"].createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1["default"].createElement("path", { d: "M1 8H15", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            react_1["default"].createElement("path", { className: "".concat(method === 'increment' ? 'inline-block' : 'hidden'), d: "M8 15V1", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));
};
exports.Stepper = Stepper;
exports["default"] = exports.Stepper;
//# sourceMappingURL=stepper.js.map